import { useEffect } from 'react';

/**
 * Hook to scroll to top when navigating to a new page.
 * Should be used on detail pages or pages that should always start at the top.
 */
export function useScrollToTop() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
}
